import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Mail, RefreshCw, Sparkles, Settings, Database, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  
  const menuItems = [
    { path: '/', icon: Home, label: 'Dashboard', bgClass: 'bg-blue-600', hoverClass: 'hover:bg-blue-700' },
    { path: '/reply', icon: Mail, label: 'Reply to Emails', bgClass: 'bg-cyan-600', hoverClass: 'hover:bg-cyan-700' },
    { path: '/follow-ups', icon: RefreshCw, label: 'Follow-up System', bgClass: 'bg-indigo-600', hoverClass: 'hover:bg-indigo-700' },
    { path: '/generate', icon: Sparkles, label: 'Generate Emails', bgClass: 'bg-purple-600', hoverClass: 'hover:bg-purple-700' },
    { path: '/settings', icon: Settings, label: 'Settings', bgClass: 'bg-gray-600', hoverClass: 'hover:bg-gray-700' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="w-64 bg-gradient-to-b from-gray-900 to-gray-800 text-white h-screen fixed left-0 top-0 shadow-2xl z-50">
      {/* Logo/Header */}
      <div className="p-6 border-b border-gray-700">
        <div className="flex items-center gap-3">
          <Database className="h-8 w-8 text-blue-400" />
          <div>
            <h1 className="text-xl font-bold">Email Automation</h1>
            <p className="text-xs text-gray-400">AI-Powered Platform</p>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                active
                  ? `${item.bgClass} text-white shadow-lg transform scale-105`
                  : `text-gray-300 hover:bg-gray-700 hover:text-white ${item.hoverClass}`
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
      {/* Footer with User & Logout */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-700 space-y-2">
        {user && (
          <p className="text-xs text-gray-400 truncate px-2" title={user.email}>{user.email}</p>
        )}
        <button
          onClick={() => { logout(); navigate('/login'); }}
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm text-gray-400 hover:text-red-400 hover:bg-gray-700 rounded-lg transition-colors"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
        <div className="text-xs text-gray-400 text-center pt-2">
          <p>Version 1.0.0</p>
          <p className="mt-1">© 2026 Email Automation</p>
        </div>
      </div>
    </div>
  );
};

export default Navigation;

